export const Entites = ['RIB', 'Facture', 'Virement', 'Administration', 'DR'] as const
export type Entites = typeof Entites[number]
